export const environment = {
  production: false,
  //apiUrl: 'https://api.klaedeskab.creavi.dk/api/',
  //hubUrl: 'https://api.klaedeskab.creavi.dk/hub/'
  apiUrl: 'https://apidetkollektiveklaedeskab.creavi.dk/api/',
  hubUrl: 'https://apidetkollektiveklaedeskab.creavi.dk/hub/'
};
